import dynamic from "next/dynamic";

export const CountrySelect = dynamic(() => import("./CountrySelect"), {
  ssr: false
});
